var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.808 6.397-2.25-2.208a1.5 1.5 0 0 0-2.118 0l-8.69 8.583-3.44-3.338a1.5 1.5 0 0 0-2.117.005l-2.25 2.25a1.5 1.5 0 0 0 0 2.12l6.715 6.75a1.5 1.5 0 0 0 2.121 0L22.812 8.522a1.5 1.5 0 0 0-.005-2.125ZM9.714 19.5 3 12.75l2.25-2.25.008.008 3.97 3.852a.75.75 0 0 0 1.049 0l9.229-9.11 2.244 2.213z"
  })));
};
export default SvgCheck;